










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

declare const google: any;

@Component({})
export default class ImageModal extends Vue {
  @Prop({ required: true })
  public mapKey!: string | number;

  @Prop({ required: true })
  public latitude!: string | number;

  @Prop({ required: true })
  public longitude!: string | number;

  @Prop({ required: true, default: false })
  public visible!: boolean;

  public hide() {
    this.$emit('hide');
  }

  @Watch('visible')
  public onVisibilityChanged(isVisible: boolean) {
    if (isVisible) {
      const loc = { lat: this.latitude, lng: this.longitude  };
      const map = new google.maps.Map(
        document.getElementById(`map-${this.mapKey}`) as HTMLElement,
        {
          zoom: 8,
          center: loc,
        }
      );
      const marker = new google.maps.Marker({
        position: loc,
        map,
        animation: google.maps.Animation.DROP,
      });
    }
  }
}
